import { useTranslation } from 'react-i18next';

import { Avatar, AvatarFallback, AvatarImage } from 'components/ui/avatar';
import { cn, formatAge } from 'lib/utils';
import useAuthStore from 'store/auth';

import Profile1 from 'assets/images/profiles/profile-1.png';

interface ProfileDetailsProps {
  onProfileChange?: (id?: string) => void;
  className?: string;
}

export default function ProfileDetails({ className }: ProfileDetailsProps) {
  const { t } = useTranslation();

  const userAttributes = useAuthStore((store) => store.userAttributes);
  const userEmail = useAuthStore((store) => store.userEmail);

  return (
    <>
      <div
        className={cn(
          'flex flex-col items-center  justify-end pb-4 space-y-4 text-white border-b-2 border-gray-500 h-2/5',
          className
        )}
      >
        <Avatar className='w-8 h-8 bg-rose-100 lg:w-11 lg:h-11'>
          <AvatarImage src={Profile1} alt='profile img' />
          <AvatarFallback>U</AvatarFallback>
        </Avatar>

        <div className='flex flex-col items-center'>
          <h4 className='text-lg font-semibold truncate max-w-3/4'>
            {userAttributes?.given_name || 'N/A'} {userAttributes?.family_name}
          </h4>
          <p className='text-sm leading-none'>{userEmail}</p>
        </div>

        <div className='flex items-center divide-x-2 divide-gray-400 gap-x-4 !mt-8 !mb-4'>
          <div className='flex flex-col items-center '>
            <p>{t('age')}</p>
            <p>{formatAge(userAttributes?.birthdate) || 1}</p>
          </div>
          <div className='flex flex-col items-center pl-4'>
            <p>{t('height')}</p>
            <p>
              {userAttributes?.height
                ? `${userAttributes?.height}${userAttributes?.height_unit}`
                : 'N/A'}
            </p>
          </div>
          <div className='flex flex-col items-center pl-4'>
            <p>{t('weight')}</p>
            <p>
              {userAttributes?.weight
                ? `${userAttributes?.weight}${userAttributes?.weight_unit}`
                : 'N/A'}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
